var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNextCircle = function SvgNextCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.208v-3.875l5.167 5.167-5.167 5.167v-3.875h-5.166v-2.584H15.5Zm0-11.625c7.13 0 12.917 5.787 12.917 12.917S22.63 28.417 15.5 28.417 2.584 22.63 2.584 15.5 8.37 2.583 15.5 2.583Zm0 23.25A10.33 10.33 0 0 0 25.834 15.5 10.33 10.33 0 0 0 15.5 5.167 10.33 10.33 0 0 0 5.167 15.5 10.33 10.33 0 0 0 15.5 25.833Z",
    fill: "#595959"
  })));
};

export default SvgNextCircle;